export const COST_CHART_HEIGHT = "clamp(360px, 40vh, 560px)";

export const MAX_DRILL_DEPTH = 2;

export type InteractiveBomView = "analytics" | "grid";
